import React from "react";
import { Link } from "react-router-dom";

import about from "../assets/images/app/app ejercicios.png";

export default function AboutTwo() {
  return (
    <div className="grid md:grid-cols-12 grid-cols-1 items-center gap-6">
      <div className="lg:col-span-4 md:col-span-6 md:order-2 order-1">
        <div className="pt-6 px-0 pb-6 rounded-2xl bg-red-500/5 dark:bg-red-500/10 shadow shadow-red-500/20 flex justify-center">
          <img className="w-20 lg:w-60 h-auto" src={about} alt="" />
        </div>
      </div>

      <div className="lg:col-span-8 md:col-span-6 md:order-1 order-2">
        <div className="lg:me-10">
          <h6 className="text-red-500 uppercase text-sm font-bold tracking-wider mb-3">
            Diseño profesional
          </h6>
          <h4 className="mb-6 md:text-3xl text-2xl md:leading-normal leading-normal font-bold">
            Asigna ejercicios de forma <br /> clara y guiada
          </h4>
          <p className="text-slate-400 max-w-xl">
            Define tipo, dificultad y objetivos para que cada cliente entienda
            exactamente qué debe hacer.
          </p>

          <ul className="list-none text-slate-400 mt-6">
            <li className="mb-1 flex">
              <i className="mdi mdi-check text-red-500 text-xl me-2"></i>{" "}
              Biblioteca de ejercicios para múltiples objetivos
            </li>
            <li className="mb-1 flex ms-0">
              <i className="mdi mdi-check text-red-500 text-xl me-2"></i>{" "}
              Planificación para personal trainers y kinesiólogos
            </li>
            <li className="mb-1 flex ms-0">
              <i className="mdi mdi-check text-red-500 text-xl me-2"></i>{" "}
              Experiencia pensada para seguimiento continuo
            </li>
          </ul>

          <div className="mt-6">
            <Link
              to=""
              className="hover:text-red-500 dark:hover:text-red-500 after:bg-red-500 dark:text-white transition duration-500 font-medium"
            >
              Conocer más <i className="mdi mdi-arrow-right align-middle"></i>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
